import React, { createContext, useContext, useState, useEffect } from 'react';
import { triggerBrowserTranslation, setupTranslationHints, clearTranslationHints } from '../utils/browserTranslation';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved preference from localStorage or default to '繁體'
    const saved = localStorage.getItem('language');
    return saved || '繁體';
  });

  // Language options
  const languageOptions = [
    { value: 'English', label: 'English', description: 'English' },
    { value: '繁體', label: '繁體', description: 'Traditional Chinese' },
    { value: '簡體', label: '簡體', description: 'Simplified Chinese' }
  ];

  useEffect(() => {
    // Save preference to localStorage whenever it changes
    localStorage.setItem('language', language);
    
    // Apply language to document
    applyLanguageToDocument(language);
  }, [language]);

  const applyLanguageToDocument = (selectedLanguage) => {
    // Remove existing language classes
    document.documentElement.className = document.documentElement.className.replace(/lang-\w+/g, '');
    
    // Add new language class
    document.documentElement.classList.add(`lang-${selectedLanguage.toLowerCase()}`);
    
    // Use the enhanced browser translation utility
    triggerBrowserTranslation(selectedLanguage);
    
    // Setup translation hints for better browser recognition
    if (selectedLanguage === 'English') {
      clearTranslationHints();
    } else {
      // Delay setup to ensure DOM is ready
      setTimeout(() => {
        setupTranslationHints();
      }, 100);
    }
  };

  const value = {
    language,
    setLanguage,
    languageOptions
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 